// Pre-connect steps: integrations where the customer must complete a manual
// step inside the third-party app BEFORE our standard connect flow can
// succeed. PreConnectStepModal intercepts every connect path (first connect,
// reconnect, add another account) for these slugs and walks the user through
// the step, then resumes the normal flow. Keyed by catalog slug
// (integrations.slug).
export type PreConnectStep = {
  // Modal heading.
  heading: string;
  // Why the extra step exists, in customer terms.
  body: string;
  // The action link, opened in a new tab.
  linkHref: string;
  linkLabel: string;
  // Reassurance for repeat connects (the modal shows on reconnects too).
  note: string;
  // Primary button label; clicking it resumes the normal connect flow.
  confirmLabel: string;
};

export const PRE_CONNECT_STEPS: Record<string, PreConnectStep> = {
  // Monday.com only completes our OAuth connect once the Composio app is
  // installed in the customer's account, and the app is not findable in
  // Monday.com's marketplace search, so we hand out the direct install link.
  monday: {
    heading: "One quick step in Monday.com first",
    body:
      "Monday.com needs the Composio app installed in your account before it will accept the connection. " +
      "Composio is the secure service we use to link Monday.com to your agent. " +
      "The app is hard to find in Monday.com's marketplace, so use this direct link and click Install when Monday.com asks.",
    linkHref:
      "https://auth.monday.com/oauth2/authorize?client_id=96b038435fc029e045f9ba800e66fefa&response_type=install",
    linkLabel: "Install the Composio app in Monday.com",
    note: "Already installed it? Just continue.",
    confirmLabel: "I've installed it, continue",
  },
};
